import { useState } from 'react'
import { EntityAutocomplete } from 'components/ui/EntityAutocomplete'
import { useCreateContact } from '../../api/aws/useCreateContact'
import ContactsDialog from './ContactsDialog'

interface Contact {
  contacts_uuid: string
  name: string
  email?: string
  photoUrl?: string
}

const PrimaryContactAutocomplete = ({
  contacts,
  label,
  onChange,
}: {
  contacts: Contact[]
  label: string
  onChange: (contacts: Contact | Contact[]) => void
}) => {
  const [dialogOpen, setDialogOpen] = useState(false)
  const [tempInput, setTempInput] = useState('')
  const [selectedPrimaryContact, setSelectedPrimaryContact] = useState<Contact | null>(null)
  const { mutate: createContact } = useCreateContact()

  const handleOpenDialog = (inputValue: string) => {
    setTempInput(inputValue)
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
    setTempInput('')
  }

  const handleCreateContacts = (newValue: any) => {
    createContact(newValue, {
      onSuccess: data => {
        const newContact = { ...data, contacts_uuid: data.contacts_uuid }
        setSelectedPrimaryContact(newContact)
        onChange(newContact)
        handleCloseDialog()
      },
    })
  }

  const handleChange = (newValue: Contact | Contact[] | null) => {
    // Single selection - convert to single contact
    const contact = Array.isArray(newValue) ? newValue[0] || null : newValue
    setSelectedPrimaryContact(contact)
    if (contact) {
      onChange(contact)
    }
  }

  return (
    <>
      <EntityAutocomplete<Contact>
        id="primary-contacts-autocomplete"
        options={contacts || []}
        value={selectedPrimaryContact}
        onChange={handleChange}
        getOptionLabel={contact => contact.name || ''}
        getOptionKey={contact => contact.contacts_uuid}
        label={label}
        multiple={false}
        avatar={{
          getPhotoUrl: contact => contact.photoUrl,
          getName: contact => contact.name || '',
          bgColor: 'rgb(255, 188, 220)',
        }}
        secondaryText={{
          getText: contact => contact.email || '',
          fontSize: 12,
        }}
        createNew={{
          enabled: true,
          onCreateNew: handleOpenDialog,
          buttonLabel: 'Add',
        }}
        freeSolo
      />
      <ContactsDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        tempInput={tempInput}
        onSaveContact={handleCreateContacts}
      />
    </>
  )
}

export default PrimaryContactAutocomplete
